var _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheeseForQuestionnaire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.2278,
    cy: 23.1281,
    r: 23.0178,
    fill: "#FFE26D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2402,
    cy: 11.2082,
    r: 4.52135,
    fill: "#F6D655"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.84164,
    cy: 17.7847,
    r: 2.87722,
    fill: "#F6D655"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.7491,
    cy: 39.1584,
    r: 2.87722,
    fill: "#F6D655"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheeseForQuestionnaire);
export default __webpack_public_path__ + "static/media/cheeseForQuestionnaire.6cff7eebb4961ab08bc0d8bac2050940.svg";
export { ForwardRef as ReactComponent };